import React from 'react'

// import IndustryBanner from '../../components/IndustryBanner';
import IndustryTab from '../../components/Industrytab';
import PageBanner from '../../components/PageBanner';


const IndustryPage = () => {
    return (
      <div className='bics-industry-wrapper'>
          <PageBanner />
          <IndustryTab />
          
      </div>
    )
  }
  
  export default IndustryPage;